export enum EVyplaty {
    D = 'D',
    Z = 'Z',
    O = 'O'
}
